import type { QuoteAck } from 'models/quote/QuoteAck';
import type { QuoteRequestPayload } from 'models/quote/QuoteRequestPayload';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface IRequestForQuotes {
  quotes: QuoteRequestPayload[];
}

export interface BatchQuoteResponse {
  quotes: QuoteResponseWithStatus[];
}
export type QuoteResponseWithStatus =
  | { status: 'Acknowledged'; acknowledgement: QuoteAck }
  | { status: 'Timeout'; newVersion: number }
  | { status: 'Failed' };

export interface BatchWorkspacePriceFormApi {
  price(request: IRequestForQuotes): Observable<BatchQuoteResponse>;
}

export function quoteRequestApi(http: IHttpClient): BatchWorkspacePriceFormApi {
  return {
    price(payload) {
      return http.postJSON<BatchQuoteResponse>({ url: 'api/v1/batch/quote', body: payload }).pipe(map(r => r.payload));
    },
  };
}
